// Polyfill ES6 Promise
import 'es6-promise/auto'

import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
// import VueProgressBar from 'vue-progressbar'
import App from 'views/App'
import { sync } from 'vuex-router-sync'
import router from './router'
import store from './store'
import collections from 'app/src/plugins/collections'
import smugmug from 'app/src/plugins/smugmug'
import page from 'app/src/plugins/page'
import globalMixin from 'app/src/mixins/global'

sync(store, router)

// Load plugins
// Vue.use(VueProgressBar, {
//   color: '#29ABE2',
//   thickness: '5px'
// })
Vue.use(collections)
Vue.use(page)
Vue.use(smugmug)
Vue.use(VueAnalytics, {
  id: 'UA-113537530-1',
  router,
  autoTracking: {
    page: process.env.NODE_ENV === 'production'
  }
})

// Load mixins
Vue.mixin(globalMixin)

// Disable production tips
Vue.config.productionTip = false

// Register global components
const ctx = require.context('components', false, /\.vue$/)
ctx.keys().forEach(key => {
  const name = key.replace('./', '').replace('.vue', '')
  Vue.component(name, ctx(key))
})

/* eslint-disable no-new */
const root = new Vue({
  router,
  store,
  template: '<App/>',
  components: { App }
})

document.addEventListener('DOMContentLoaded', () => {
  root.$mount('#app')
})



// WEBPACK FOOTER //
// ./app/src/main.js